import React, { useState, useEffect, useMemo, act, use } from "react";
import "./All.css";
import Navbar from "../About/Navbar";
import Footer from "../About/Footer";
import Hero from "../CompanyHome/Hero";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import ScheduleInterviewModal from "./Popup";
import ScheduleTestt from "./ScheduleTest"; // Test Cards Popup
import VideoPopup from "./VideoPopup";
import AudioPopup from "./AudioPopup";
import UploadPopup from "../CompanyHome/UploadResume";
import MeetingInsightsModal from "../../CompanyAdmin/Content/CompanyActions/JobActions/MeetingInsightsModal";

const CandidateList = () => {
  const [hoveredCandidates, setHoveredCandidates] = useState({});
  const [showJobDescription, setShowJobDescription] = useState(false);
  const [showUploadResume, setShowUploadResume] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const jobId = new URLSearchParams(location.search).get("jobID");
  const [contactPopup, setContactPopup] = useState(false);
  const [cemail, setcemail] = useState("");
  const [cphone, setcphone] = useState("");
  const [contactCandidate, setContactCandidate] = useState(null);
  const [jobDetails, setJobDetails] = useState({});
  const [candidates, setCandidates] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedTestCard, setSelectedTestCard] = useState(null);
  const [showScheduleTestPopup, setShowScheduleTestPopup] = useState(false);
  const [insightsCandidate, setInsightsCandidate] = useState(null);
  // const [isFilterOpen, setIsFilterOpen] = useState(false);
  // const [hover, setHover] = useState(null);
  // const [filters, setFilters] = useState({
  //   location: "",
  //   experience: 0,
  //   match: [],
  //   gender: [],
  //   interviewNotScheduled: false
  // });
  const [showVideo, setShowVideo] = useState(false);
  const [showAudio, setShowAudio] = useState(false);
  const [sortingCriteria, setSortingCriteria] = useState("Resume_Score");
  const [scoreFilterType, setScoreFilterType] = useState(""); // Which score type is selected
  const [minScore, setMinScore] = useState(0);
  const [maxScore, setMaxScore] = useState(100);
  const [interviewFilter, setInterviewFilter] = useState(""); // "1" for scheduled, "0" for not scheduled
  let [filterCandidates, setFilterCandidates] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [skillQuery, setSkillQuery] = useState("");
  const [relevanceFilter, setRelevanceFilter] = useState("all");

const parseCriticalSkills = (candidate) => {
  try {
    let missingSkills = [];
    let penalty = candidate.penalty_applied || 0;
    let baseScore = candidate.base_score || candidate.Resume_Score;
    
    // Parse critical_skills_missing field
    if (candidate.critical_skills_missing) {
      if (typeof candidate.critical_skills_missing === 'string') {
        try {
          missingSkills = JSON.parse(candidate.critical_skills_missing);
        } catch (e) {
          // If JSON parsing fails, try to parse as comma-separated string
          const cleanString = candidate.critical_skills_missing.replace(/[\[\]'"]/g, '');
          missingSkills = cleanString.split(',').filter(skill => skill.trim() !== '');
        }
      } else if (Array.isArray(candidate.critical_skills_missing)) {
        missingSkills = candidate.critical_skills_missing;
      }
    }
    
    // Also check if penalty details exist in skill_penalty_details
    if (candidate.skill_penalty_details) {
      try {
        const penaltyDetails = JSON.parse(candidate.skill_penalty_details);
        if (penaltyDetails.penalty_applied !== undefined) {
          penalty = penaltyDetails.penalty_applied;
        }
        if (penaltyDetails.critical_skills_penalty !== undefined) {
          penalty = penaltyDetails.critical_skills_penalty;
        }
      } catch (e) {
        console.log("Error parsing penalty details:", e);
      }
    }
    
    return {
      missingSkills: missingSkills,
      penalty: penalty,
      baseScore: baseScore
    };
  } catch (error) {
    console.error("Error parsing critical skills:", error);
    return { missingSkills: [], penalty: 0, baseScore: candidate.Resume_Score };
  }
};

  const handleUploadSuccess = (newCandidates) => {
    // Add new candidates to the top of the list
    setCandidates(prev => [...newCandidates, ...prev]);
    setSortingCriteria("upload_date_desc"); // Show new resumes at top
  };

  const handleVideoPopup = (candidate) => {
    setSelectedCandidate(candidate);
    setShowVideo(true);
  };

  const handleAudioPopup = (candidate) => {
    setSelectedCandidate(candidate);
    setShowAudio(true);
  };

  // Format skills as bullet points
  const formatSkillsAsBullets = (skillsString) => {
    if (!skillsString) return <p>N/A</p>;

    // Clean up the string by removing brackets and quotes
    let cleanString = skillsString;
    if (typeof skillsString === 'string') {
      cleanString = skillsString.replace(/[\[\]']/g, '');
    }

    // Split the string by commas and create bullet points
    const skillsList = typeof cleanString === 'string'
      ? cleanString.split(',').filter(skill => skill.trim() !== '')
      : [];

    // If it's the summary which is a paragraph, not a list
    if (skillsList.length <= 1 && cleanString.length > 30) {
      return <p>{cleanString}</p>;
    }

    return (
      <ul>
        {skillsList.map((skill, index) => (
          <li key={index}>{skill.trim()}</li>
        ))}
      </ul>
    );
  };

  const [showInterviewModal, setShowInterviewModal] = useState(false);

  // Filter candidates based on activeTab selection
  const filteredCandidatesShortlisted = useMemo(() => {
    setSelectedCandidates([]);
    if (activeTab === "shortlisted") {
      // setFilterCandidates(candidates.filter(candidate => candidate.isShortlisted && !candidate.isRejected));
      return candidates.filter(candidate => candidate.isShortlisted && !candidate.isRejected);
    }

    else if (activeTab === "interview") {
      // Get today's date for comparison
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const interviewScheduledCandidate = candidates.filter(candidate => candidate.isInterviewScheduled && !candidate.isRejected);

      // Filter the schedules to show only those that are today or in the future
      const upcomingSchedules = interviewScheduledCandidate.filter(schedule => {
        const screening_schedule_date = new Date(schedule.screening_scheduled_time);
        const personality_schedule_date = new Date(schedule.personality_scheduled_time);
        const behavioral_schedule_date = new Date(schedule.behavioral_scheduled_time);
        const coding_schedule_date = new Date(schedule.coding_scheduled_time);

        return screening_schedule_date >= today || personality_schedule_date >= today || behavioral_schedule_date >= today || coding_schedule_date >= today;
      });

      return upcomingSchedules
      // setFilterCandidates(candidates.filter(candidate => candidate.isInterviewScheduled && !candidate.isRejected));
      // return candidates.filter(candidate => candidate.isInterviewScheduled && !candidate.isRejected);
    }

    else if (activeTab === "rejected") {
      // setFilterCandidates(candidates.filter(candidate => candidate.isRejected));
      return candidates.filter(candidate => candidate.isRejected);
    }

    // setFilterCandidates(candidates.filter(candidate => !candidate.isRejected));
    return candidates.filter(candidate => !candidate.isRejected);
  }, [activeTab, candidates]);

  // Use useEffect to apply filters after setting the filtered candidates
  useEffect(() => {
    applyFilters();
  }, [filteredCandidatesShortlisted]);

  useEffect(() => {
    console.log("Selected Candidates updated:", selectedCandidates);
  }, [selectedCandidates]);

  const handleCheckboxChange = (candidateEmail) => {
    setSelectedCandidates((prevSelected) => {

      if (prevSelected.includes(candidateEmail)) {
        return prevSelected.filter(email => email !== candidateEmail); // Unselect
      } else {
        return [...prevSelected, candidateEmail]; // Select
      }

    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allEmails = filterCandidates.map(candidate => candidate.email);
      setSelectedCandidates(allEmails);
    } else {
      setSelectedCandidates([]);
    }
  };
  const handleScheduleInterviewsForSelected = () => {
    setShowInterviewModal(true);
    // selectedCandidates.forEach(email => {
    //   const candidate = candidates.find(c => c.email === email);
    //   if (candidate) {
    //     handleScheduleInterview(candidate); // Call your existing function
    //   }
    // });
  };
  const handleScheduleInterview = (candidate) => {
    setSelectedCandidate(candidate);
    setSelectedCandidates([candidate.email]);
    setShowInterviewModal(true);
  };

  const handleCloseModal = () => {
    setShowInterviewModal(false);
    setSelectedCandidate(null);
    setSelectedCandidates([]);
    setShowScheduleTestPopup(false);
    setSelectedTestCard(null);
  };

  const handleSelectTest = (selectedArray) => {
    setSelectedCandidates(selectedArray);
    setShowScheduleTestPopup(true); // Open Test Cards Popup
  };

  const handleCloseScheduleTestPopup = () => {
    setShowScheduleTestPopup(false);
  };

  const handleSelectTestCard = (card) => {
    setSelectedTestCard(card);
    setShowScheduleTestPopup(false);
  };

  const applyFilters = () => {
    let filtered = [...filteredCandidatesShortlisted];

    // Apply Search Filter
    if (searchQuery.trim() !== "") {
      filtered = filtered.filter(candidate =>
        candidate.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply Search by Skills
    if (skillQuery.trim() !== "") {
      filtered = filtered.filter(candidate =>
        candidate.skills_matching.toLowerCase().includes(skillQuery.toLowerCase()) ||
        candidate.skills.toLowerCase().includes(skillQuery.toLowerCase())
      );
    }

    // Apply Interview Scheduled Filter (Yes / No / None)
    if (interviewFilter !== "") {
      console.log(interviewFilter);
      filtered = filtered.filter(candidate =>
        interviewFilter === "1" ? candidate.isInterviewScheduled : !candidate.isInterviewScheduled
      );
    }

    // Apply Relevance Match Filter
    if (relevanceFilter === "great") {
      filtered = filtered.filter(candidate => candidate.Resume_Score >= 80);
    } else if (relevanceFilter === "good") {
      filtered = filtered.filter(candidate => candidate.Resume_Score >= 50 && candidate.Resume_Score < 80);
    }

    // Apply Sorting
    if (sortingCriteria) {
      if (sortingCriteria === 'upload_date_desc') {
        filtered = filtered.sort((a, b) => 
          new Date(b.created_at) - new Date(a.created_at));
      } 
      else if (sortingCriteria === 'upload_date_asc') {
        filtered = filtered.sort((a, b) => 
          new Date(a.created_at) - new Date(b.created_at));
      }
      else {
        // Existing numeric sorting
        filtered = filtered.sort((a, b) => (b[sortingCriteria] || 0) - (a[sortingCriteria] || 0));
      }
    }

    // Apply Score Range Filter
    if (scoreFilterType) {
      filtered = filtered.filter(candidate => {
        const score = candidate[scoreFilterType] || 0;
        return score >= minScore && score <= maxScore;
      });
    }

    setFilterCandidates(filtered);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSkillSearchChange = (e) => setSkillQuery(e.target.value);

  // Call applyFilters whenever searchQuery changes
  useEffect(() => {
    applyFilters();
  }, [searchQuery, skillQuery]);

  const handleToggleShortlist = async (candidateId, currentStatus) => {
    const newStatus = !currentStatus;
    try {
      fetch(`/api/update-shortlist?jobId=${jobId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ candidateId, isShortlisted: newStatus }),
      });
      // Update local candidate state
      const updatedCandidates = candidates.map((candidate) =>
        candidate.email === candidateId
          ? { ...candidate, isShortlisted: newStatus, isRejected: false }
          : candidate
      );
      setCandidates(updatedCandidates);
    } catch (error) {
      console.error("Error updating shortlist status:", error);
    }
  };

  // Function to toggle shortlist status and call backend
  const handleToggleReject = async (candidateId) => {
    try {
      if (activeTab === "rejected") {
        // If the user is on the rejected tab, remove the candidate
        fetch(`/api/delete-candidate?jobId=${jobId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ candidateId }),
        });
        const updatedCandidates = candidates.filter((candidate) => candidate.email !== candidateId);
        setCandidates(updatedCandidates);
      }
      else {
        fetch(`/api/update-reject?jobId=${jobId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ candidateId }),
        });
        // Update local candidate state
        const updatedCandidates = candidates.map((candidate) =>
          candidate.email === candidateId
            ? { ...candidate, isRejected: true, isShortlisted: false }
            : candidate
        );
        setCandidates(updatedCandidates);
      }
    } catch (error) {
      console.error("Error updating shortlist status:", error);
    }
  };

  // Function to handle contact update
  const saveNewEmailPhone = async () => {
    if (!contactCandidate) {
      alert("No candidate selected.");
      return;
    }

    try {
      const response = await fetch(`/api/update-contact-info?jobId=${jobId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          candidateId: contactCandidate.email, // or selectedCandidate.id if that's the unique key
          email: cemail,
          name: cphone,
        }),
      });

      if (!response.ok) {
        setContactCandidate(null);
        throw new Error("Failed to update contact info");
      }

      // Update the local candidate state
      const updatedCandidates = candidates.map((candidate) =>
        candidate.email === contactCandidate.email
          ? { ...candidate, email: cemail, name: cphone }
          : candidate
      );
      setCandidates(updatedCandidates);

      // Optional: Close popup and show success
      setContactPopup(false);
      setContactCandidate(null);
      alert("Contact info updated successfully!");
    } catch (error) {
      setContactCandidate(null);
      console.error("Error updating contact info:", error);
      alert("Failed to update contact info. Please try again.");
    }
  };


  const handleContactPopup = (candidate) => {
    setContactCandidate(candidate);
    setcemail(candidate.email);
    setcphone(candidate.name);
    setContactPopup(true);
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // "2025-03-04"
  };

  const convertToIST = (gmtDate) => {
    // Create a Date object from the GMT date string
    const date = new Date(gmtDate);

    // Format the date to a beautified string (e.g., March 13, 2025, 12:46 PM)
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // To show AM/PM
    };
    return date.toLocaleString('en-IN', options);
  };

  const resetFilters = () => {
    setSortingCriteria(""); // Reset sorting
    setInterviewFilter(""); // Reset interview filter
    setScoreFilterType(""); // Reset score filter type
    setMinScore(0); // Reset min score
    setMaxScore(100); // Reset max score
    setSkillQuery(""); // Reset skill query
    setRelevanceFilter("all"); // Reset relevance filter to default "All"
    setFilterCandidates(filteredCandidatesShortlisted); // Show all candidates again
  };

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const response = await fetch(`/api/candidatelist?jobId=${jobId}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log("Candidates:", data);
        setCandidates(data);
        // setFilterCandidates(data);

        if (data.length > 0) {
          // Store basic job details from the first candidate
          setJobDetails({
            job_title: data[0].job_title,
            location: data[0].location,
            experience_range: data[0].company_experience,
            job_type: data[0].job_type || null,

          });

          // Fetch complete job description details
          fetchJobDescription(jobId);
        }
      } catch (error) {
        console.error("Error fetching candidates:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchJobDescription = async (jobId) => {
      try {
        const response = await fetch(`/api/job_description?jobId=${jobId}`);
        if (response.ok) {
          const jobData = await response.json();
          console.log("Job Description:", jobData);
          setJobDetails(prevDetails => ({
            ...prevDetails,
            overview: jobData.overview,
            responsibilities: jobData.responsibilities,
            requirements: jobData.requirements,
            salary_range: jobData.salary_range,

            job_type: jobData.job_type
          }));
        }
      } catch (error) {
        console.error("Error fetching job description:", error);
      }
    };

    fetchCandidates();
  }, [jobId]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <Navbar />
      <Hero />
      <div className="all-candidates">
        {/* <div className="filter-dropdown-container"> */}
        {/* <button className="filter-toggle" onClick={toggleFilter}>Apply Filter</button> */}
        {/* {isFilterOpen && (  */}
        <div className="filter-panel">
          <h3>Filter Candidates</h3>
          {/* Sorting Dropdown */}
          <label>Sort By:</label>
          <select onChange={(e) => setSortingCriteria(e.target.value)} style={{ width: "100%", borderRadius: "5px", padding: "4px", fontSize: "12px" }}>
            <option value="Resume_Score">Resume Score</option>
            <option value="screening_overall_score">Screening Test Score</option>
            <option value="personality_overall_score">Personality Test Score</option>
            <option value="behavioral_overall_score">Behavioral Test Score</option>
            <option value="coding_overall_score">Coding Test Score</option>
            <option value="upload_date_desc">Upload Date (Newest First)</option>
            <option value="upload_date_asc">Upload Date (Oldest First)</option>
          </select>

          {/* Search by Skills */}
          <label>Search Candidates by Skill:</label>
          <input
            type="text"
            className="search-bar-all"
            placeholder="Enter skill (e.g., Java, Python)"
            value={skillQuery}
            onChange={handleSkillSearchChange}
          />

          {/* Filter by Relevance Match */}
          <label>Filter by Relevance Match:</label>
          <select
            style={{ width: "100%", borderRadius: "5px", padding: "4px", fontSize: "12px" }}
            value={relevanceFilter}
            onChange={(e) => setRelevanceFilter(e.target.value)}
          >
            <option value="all">All</option>
            <option value="great">Great (Resume Score ≥ 80)</option>
            <option value="good">Good (Resume Score ≥ 50)</option>
          </select>

          {/* Score Type Selection */}
          <label>Filter By Score Type:</label>
          <select onChange={(e) => setScoreFilterType(e.target.value)} style={{ width: "100%", borderRadius: "5px", padding: "4px", fontSize: "12px" }}>
            <option value="">None</option>
            <option value="Resume_Score">Resume Score</option>
            <option value="screening_overall_score">Screening Test Score</option>
            <option value="personality_overall_score">Personality Test Score</option>
            <option value="behavioral_overall_score">Behavioral Test Score</option>
            <option value="coding_overall_score">Coding Test Score</option>
          </select>

          {/* Score Range Filters */}
          {scoreFilterType && (
            <>
              <div style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
                <div style={{ width: "50%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <label>Min Score:</label>
                  <input
                    style={{ width: "100%", padding: "4px", fontSize: "12px", borderRadius: "5px" }}
                    type="number"
                    min="0"
                    max="100"
                    value={minScore}
                    onChange={(e) => setMinScore(Number(e.target.value))}
                  />
                </div>
                <div style={{ width: "50%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <label>Max Score:</label>
                  <input
                    style={{ width: "100%", padding: "4px", fontSize: "12px", borderRadius: "5px" }}
                    type="number"
                    min="0"
                    max="100"
                    value={maxScore}
                    onChange={(e) => setMaxScore(Number(e.target.value))}
                  />
                </div>
              </div>
            </>
          )}

          {/* Interview Scheduled Filter */}
          <label>Interview Scheduled:</label>
          <div style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <input
                type="radio"
                name="interviewStatus"
                value="1"
                checked={interviewFilter === "1"}
                onChange={() => setInterviewFilter("1")}
              />
              <label>Yes</label>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <input
                type="radio"
                name="interviewStatus"
                value="0"
                checked={interviewFilter === "0"}
                onChange={() => setInterviewFilter("0")}
              />
              <label>No</label>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <input
                type="radio"
                name="interviewStatus"
                value=""
                checked={interviewFilter === ""}
                onChange={() => setInterviewFilter("")}
              />
              <label>None</label>
            </div>
          </div>

          {/* Apply Filter Button */}
          <div style={{ display: "flex", gap: "10px" }}>
            <button onClick={applyFilters} style={{ borderRadius: "5px", padding: "4px", fontSize: "12px" }}>Apply Filter</button>
            <button onClick={resetFilters} style={{ borderRadius: "5px", padding: "4px", fontSize: "12px" }}>Reset Filter</button>
          </div>
        </div>
        {/* )} */}

        {/* </div> */}
        <div className="ranking-job-header-v2">
          <div className="job-title-section">
            <h2 onClick={() => setShowJobDescription(true)} className="clickable-job-title">
              {jobDetails.job_title}
            </h2>
            <span onClick={() => setShowJobDescription(true)} className="job-badge">View Details</span>
            <span className="job-badge" onClick={() => setShowUploadResume(true)}>Upload Resume</span>
            {showUploadResume && (
              <UploadPopup
                jobId={jobId}
                onClose={() => setShowUploadResume(false)}
                onUploadSuccess={handleUploadSuccess}
              />
            )}
          </div>
          <div className="job-meta-info">
            <div className="job-meta-item">
              <span className="meta-icon">📍</span>
              <span className="meta-text">{jobDetails.location || 'Location not specified'}</span>
            </div>
            <div className="job-meta-item">
              <span className="meta-icon">⏱️</span>
              <span className="meta-text">{jobDetails.experience_range || 'Experience not specified'}</span>
            </div>
            <div className="job-meta-item">
              <span className="meta-icon">🔢</span>
              <span className="meta-text">Job Code: {jobId}</span>
            </div>
          </div>
        </div>
        {showJobDescription && (
          <div className="modal-overlay">
            <div className="job-description-popup">
              <div className="job-description-header">
                <h2>{jobDetails.job_title}</h2>
                <button className="close-button" onClick={() => setShowJobDescription(false)}>×</button>
              </div>

              <div className="job-description-content">
                {/* Top Info Cards */}
                <div className="jd-info-cards">
                  <div className="jd-info-card">
                    <div className="info-icon">📍</div>
                    <div className="info-content">
                      <div className="info-label">Location</div>
                      <div className="info-value">{jobDetails.location || 'Not specified'}</div>
                    </div>
                  </div>

                  <div className="jd-info-card">
                    <div className="info-icon">💼</div>
                    <div className="info-content">
                      <div className="info-label">Job Type</div>
                      <div className="info-value">{jobDetails.job_type || 'Not specified'}</div>
                    </div>
                  </div>

                  <div className="jd-info-card">
                    <div className="info-icon">⏱️</div>
                    <div className="info-content">
                      <div className="info-label">Experience</div>
                      <div className="info-value">{jobDetails.experience_range || 'Not specified'}</div>
                    </div>
                  </div>

                  <div className="jd-info-card">
                    <div className="info-icon">💰</div>
                    <div className="info-content">
                      <div className="info-label">Salary</div>
                      <div className="info-value">{jobDetails.salary_range || 'Not specified'}</div>
                    </div>
                  </div>
                </div>

                {/* Job Overview */}
                <div className="jd-section">
                  <h3>Job Overview</h3>
                  <p>{jobDetails.overview || 'No overview available'}</p>
                </div>

                {/* Responsibilities */}
                <div className="jd-section">
                  <h3>Key Responsibilities</h3>
                  <ul>
                    {jobDetails.responsibilities ?
                      jobDetails.responsibilities.split(/•|\n/).filter(item => item.trim()).map((item, index) => (
                        <li key={index}>{item.trim()}</li>
                      )) :
                      <li>No responsibilities specified</li>
                    }
                  </ul>
                </div>

                {/* Required Skills */}
                <div className="jd-section">
                  <h3>Required Skills</h3>
                  <ul>
                    {jobDetails.requirements ?
                      jobDetails.requirements.split(/•|\n/).filter(item => item.trim()).map((item, index) => (
                        <li key={index}>{item.trim()}</li>
                      )) :
                      <li>No requirements specified</li>
                    }
                  </ul>
                </div>

                {/* Optional Skills */}
                {jobDetails.optional_skills && (
                  <div className="jd-section">
                    <h3>Good to Have Skills</h3>
                    <ul>
                      {jobDetails.optional_skills.split(/•|\n/).filter(item => item.trim()).map((item, index) => (
                        <li key={index}>{item.trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Soft Skills */}
                {jobDetails.soft_skills && (
                  <div className="jd-section">
                    <h3>Soft Skills</h3>
                    <ul>
                      {jobDetails.soft_skills.split(/•|\n/).filter(item => item.trim()).map((item, index) => (
                        <li key={index}>{item.trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Company Overview */}
                {jobDetails.company_overview && (
                  <div className="jd-section">
                    <h3>About the Company</h3>
                    <p>{jobDetails.company_overview}</p>
                  </div>
                )}

                {/* Job Details Grid */}
                <div className="jd-section">
                  <h3>Additional Details</h3>
                  <div className="jd-details-grid">
                    <div className="jd-detail-item">
                      <span className="detail-label">Employment Type</span>
                      <span className="detail-value">{jobDetails.employment_type || 'Not specified'}</span>
                    </div>

                    <div className="jd-detail-item">
                      <span className="detail-label">Work Hours</span>
                      <span className="detail-value">{jobDetails.work_hours || 'Not specified'}</span>
                    </div>

                    <div className="jd-detail-item">
                      <span className="detail-label">Travel Requirements</span>
                      <span className="detail-value">{jobDetails.travel_requires || 'Not specified'}</span>
                    </div>

                    <div className="jd-detail-item">
                      <span className="detail-label">Application Deadline</span>
                      <span className="detail-value">
                        {jobDetails.application_deadline ?
                          new Date(jobDetails.application_deadline).toLocaleDateString('en-US', {
                            year: 'numeric', month: 'long', day: 'numeric'
                          }) : 'Not specified'}
                      </span>
                    </div>

                    <div className="jd-detail-item">
                      <span className="detail-label">Job ID</span>
                      <span className="detail-value">{jobId}</span>
                    </div>
                  </div>
                </div>

                {/* Application Process */}
                {jobDetails.how_to_apply && (
                  <div className="jd-section">
                    <h3>Application Process</h3>
                    <p>{jobDetails.how_to_apply}</p>
                  </div>
                )}

                {/* Preferences Section */}
                {(jobDetails.preferrence_one || jobDetails.preferrence_two || jobDetails.preferrence_three) && (
                  <div className="jd-section">
                    <h3>Hiring Preferences</h3>
                    <div className="preferences-container">
                      {jobDetails.preferrence_one && (
                        <div className="preference-item">
                          <div className="preference-label">Primary Preference</div>
                          <div className="preference-value">{jobDetails.preferrence_one}</div>
                        </div>
                      )}

                      {jobDetails.preferrence_two && (
                        <div className="preference-item">
                          <div className="preference-label">Secondary Preference</div>
                          <div className="preference-value">{jobDetails.preferrence_two}</div>
                        </div>
                      )}

                      {jobDetails.preferrence_three && (
                        <div className="preference-item">
                          <div className="preference-label">Additional Preference</div>
                          <div className="preference-value">{jobDetails.preferrence_three}</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="tabs2-v22">
          <button></button>
          <button className='active-tab'>Applications ({candidates.length})</button>
          <button></button>
          <button onClick={() => {
            navigate(`/results?jobID=${jobId}`, { state: { jobDetails: jobDetails, len: candidates.length } });
          }}>Interview Result</button>
          <button></button>
        </div>
        <div className="all-filters">
          <input
            type="text"
            className="search-bar-all"
            placeholder="Search candidates"
            value={searchQuery}
            onChange={handleSearchChange}
          />

          {(activeTab !== "interview" && activeTab !== "rejected") && (
            <>
              <div className="select-all-combined">
                <input
                  type="checkbox"
                  className="select-all"
                  checked={filterCandidates.length > 0 && filterCandidates.length === selectedCandidates.length}
                  onChange={handleSelectAll}
                />
                <label className="select-all-label">Select All</label>
              </div>
            </>
          )}
          <button
            className={`glbtn ${selectedCandidates.length === 0 ? "disabled" : ""}`}
            onClick={handleScheduleInterviewsForSelected}
            disabled={selectedCandidates.length === 0}
          >
            Schedule Interview
          </button>
          {/* {(activeTab === "all" || activeTab === "shortlisted") && selectedCandidates.length > 0 && (
            <button className="glbtn" onClick={handleScheduleInterviewsForSelected}>
              Schedule Interview
            </button>
          )} */}
        </div>
        <div className="tabs2-v222">
          <button className={activeTab === "all" ? "active-tab" : ""} onClick={() => { setActiveTab("all");}}>All ({candidates.filter(candidate => !candidate.isRejected).length})</button>
          <button className={activeTab === "shortlisted" ? "active-tab" : ""} onClick={() => { setActiveTab("shortlisted"); }}>Shortlisted ({candidates.filter(candidate => candidate.isShortlisted && !candidate.isRejected).length})</button>
          <button className={activeTab === "interview" ? "active-tab" : ""} onClick={() => {
            setActiveTab("interview");
          }}>Upcoming Interviews</button>
          <button className={activeTab === "rejected" ? "active-tab" : ""} onClick={() => { setActiveTab("rejected"); }}>Rejected ({candidates.filter(candidate => candidate.isRejected).length})</button>
        </div>
        <div className="candidate-container-all" style={{ minHeight: "80vh" }}>
          {filterCandidates.length === 0 ? (
            <p>No candidates available</p>
          ) : (
            filterCandidates.map((candidate, index) => {
              // Parse critical skills for this candidate
              const { missingSkills, penalty, baseScore } = parseCriticalSkills(candidate);
              
              return (
                <div key={candidate.email} className="candidate-card">
                  {/* Checkbox for selection */}
                  {activeTab !== "interview" && activeTab !== "rejected" && (
                    <input
                      type="checkbox"
                      className="candidate-checkbox"
                      checked={selectedCandidates.includes(candidate.email)}
                      onChange={() => handleCheckboxChange(candidate.email)}
                    />
                  )}

                  {/* Candidate Header with Avatar */}
                  <div className="candidate-header-details-skills">
                    <div className="candidate-header-details">
                      <div className="candidate-header">
                        <img src="user.jpg" alt="Avatar" className="candidate-avatar" />
                        <h2 className="candidate-name">
                          {candidate.name}
                          <span className="candidate-match">
                            is {candidate.Resume_Score >= 80 ? "a Great Match" : candidate.Resume_Score >= 50 ? "a Good Match" : "a Weak Match"}
                          </span>
                        </h2>
                      </div>

                      {/* Candidate Details */}
                      <div className="candidate-details">
                        <p><strong>Experience:</strong> {candidate.experience} years</p>
                        <p><strong>Qualification:</strong> {candidate.qualification}</p>
                        <p><strong>Current Location:</strong> {candidate.currentLocation}</p>
                        <p><strong>Preferred Location:</strong> {candidate.preferredLocation}</p>
                        <p><strong>Notice Period:</strong> No</p>
                        <p><strong>Applied on:</strong> {convertToIST(candidate.created_at)}</p>
                        
                        {/* Critical Skills Section */}
                        <div className="critical-skills-section">
                          {missingSkills.length > 0 && (
                            <div className="critical-skills-warning">
                              <span className="critical-icon">⚠️</span>
                              <span className="critical-text">
                                {missingSkills.length} critical skill{missingSkills.length > 1 ? 's' : ''} missing
                                {penalty > 0 && `(-${penalty}% penalty)`}
                              </span>
                            </div>
                          )}
                          {missingSkills.length === 0 && penalty === 0 && (
                            <div className="critical-skills-success">
                              <span className="critical-icon">✅</span>
                              <span className="critical-text">All critical skills met</span>
                            </div>
                          )}

                          {/* Code-plagiarism chip — only shows when there's
                              meaningful signal (≥ 30%). Reads the legacy
                              `plagiarism_percentage` column which is now
                              fed by Layer 6 (MOSS + LLM judge). Defensive:
                              if the field isn't on the row (e.g. candidate
                              hasn't taken the coding test yet), the chip
                              silently hides — same UX pattern as the
                              critical-skills warning above. */}
                          {Number(candidate.plagiarism_percentage) >= 50 && (
                            <div
                              className="critical-skills-warning"
                              style={{
                                background: '#fef2f2',
                                color: '#991b1b',
                                borderColor: '#fca5a5',
                              }}
                            >
                              <span className="critical-icon">🛡️</span>
                              <span className="critical-text">
                                High code plagiarism:&nbsp;
                                {Math.round(Number(candidate.plagiarism_percentage))}% &nbsp;— manual review
                              </span>
                            </div>
                          )}
                          {Number(candidate.plagiarism_percentage) >= 30 &&
                           Number(candidate.plagiarism_percentage) < 50 && (
                            <div
                              className="critical-skills-warning"
                              style={{
                                background: '#fefce8',
                                color: '#854d0e',
                                borderColor: '#fde047',
                              }}
                            >
                              <span className="critical-icon">⚠️</span>
                              <span className="critical-text">
                                Code plagiarism:&nbsp;
                                {Math.round(Number(candidate.plagiarism_percentage))}%
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className="candidate-skill-info-container"
                      onMouseLeave={() => {
                        setHoveredCandidates(prev => ({
                          ...prev,
                          [candidate.email]: null
                        }));
                      }}
                    >
                      {/* Always show the grid */}
                      <div className="skill-tabs-grid">
                        <div
                          className={`skill-tab-card ${hoveredCandidates[candidate.email] === "missing" ? "active" : ""}`}
                          onMouseEnter={() => setHoveredCandidates(prev => ({
                            ...prev,
                            [candidate.email]: "missing"
                          }))}
                        >
                          <div className="tab-label">Missing Skills</div>
                        </div>
                        <div
                          className={`skill-tab-card ${hoveredCandidates[candidate.email] === "matching" ? "active" : ""}`}
                          onMouseEnter={() => setHoveredCandidates(prev => ({
                            ...prev,
                            [candidate.email]: "matching"
                          }))}
                        >
                          <div className="tab-label">Matching Skills</div>
                        </div>
                        <div
                          className={`skill-tab-card ${hoveredCandidates[candidate.email] === "strengths" ? "active" : ""}`}
                          onMouseEnter={() => setHoveredCandidates(prev => ({
                            ...prev,
                            [candidate.email]: "strengths"
                          }))}
                        >
                          <div className="tab-label">Strengths</div>
                        </div>
                        <div
                          className={`skill-tab-card ${hoveredCandidates[candidate.email] === "summary" ? "active" : ""}`}
                          onMouseEnter={() => setHoveredCandidates(prev => ({
                            ...prev,
                            [candidate.email]: "summary"
                          }))}
                        >
                          <div className="tab-label">Overall Summary</div>
                        </div>
                        
                        {/* Add Critical Skills Tab */}
                        <div
                          className={`skill-tab-card critical ${hoveredCandidates[candidate.email] === "critical" ? "active" : ""}`}
                          onMouseEnter={() => setHoveredCandidates(prev => ({
                            ...prev,
                            [candidate.email]: "critical"
                          }))}
                        >
                          <div className="tab-label">Critical Skills</div>
                        </div>
                      </div>

                      {/* Show hover content when a tab is active */}
                      {hoveredCandidates[candidate.email] && (
                        <div className={`hover-content ${["missing", "matching", "critical"].includes(hoveredCandidates[candidate.email]) ? "up" : "down"}`}>
                          <div className="hover-skill-box">
                            <div className="hover-header">
                              <div className="hover-icon">
                                {hoveredCandidates[candidate.email] === "missing" ? "❌" :
                                hoveredCandidates[candidate.email] === "matching" ? "✓" :
                                hoveredCandidates[candidate.email] === "strengths" ? "⭐" :
                                hoveredCandidates[candidate.email] === "critical" ? "⚠️" : "📋"}
                              </div>
                              <strong className="skill-title">
                                {hoveredCandidates[candidate.email] === "missing" ? "Missing Skills" :
                                hoveredCandidates[candidate.email] === "matching" ? "Matching Skills" :
                                hoveredCandidates[candidate.email] === "strengths" ? "Strengths" :
                                hoveredCandidates[candidate.email] === "critical" ? "Critical Skills" : "Overall Summary"}
                              </strong>
                            </div>
                            <div className="skill-content">
                              {hoveredCandidates[candidate.email] === "critical" ? (
                                <div className="critical-skills-details">
                                  {missingSkills.length > 0 ? (
                                    <>
                                      <div className="critical-skills-list">
                                        {missingSkills.map((skill, index) => (
                                          <span key={index} className="critical-skill-tag">
                                            {skill}
                                          </span>
                                        ))}
                                      </div>
                                      {penalty > 0 && (
                                        <div className="penalty-info">
                                          Penalty Applied: -{penalty}%
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <div className="no-critical-missing">
                                      ✅ All critical skills are met
                                    </div>
                                  )}
                                </div>
                              ) : (
                                formatSkillsAsBullets(
                                  hoveredCandidates[candidate.email] === "missing"
                                    ? candidate.missing_skills
                                    : hoveredCandidates[candidate.email] === "matching"
                                      ? candidate.skills_matching
                                      : hoveredCandidates[candidate.email] === "strengths"
                                        ? candidate.strengths
                                        : candidate.overall_summary
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="candidate-actions">
                    <button
                      className={`btn primary ${candidate.isShortlisted ? "shortlisted" : ""}`}
                      onClick={() => handleToggleShortlist(candidate.email, candidate.isShortlisted)}
                    >
                      {candidate.isShortlisted ? "Shortlisted" : "Shortlist"}
                    </button>

                    <button
                      className={`btn destructive ${candidate.isRejected ? "delete" : ""}`}
                      onClick={() => handleToggleReject(candidate.email, candidate.isRejected)}
                    >
                      {candidate.isRejected ? "Delete" : "Reject"}
                    </button>

                    <button className="btn secondary" onClick={() => handleVideoPopup(candidate)}>View Video</button>
                    <button className="btn secondary" onClick={() => handleAudioPopup(candidate)}>View Audio</button>
                    <button className="btn neutral" onClick={() => setInsightsCandidate(candidate)}>
                      Insights
                    </button>

                    {activeTab !== "interview" && (
                      <button className="btn neutral" onClick={() => handleScheduleInterview(candidate)}>
                        Schedule Interview
                      </button>
                    )}

                    <button className="btn neutral" onClick={() => handleContactPopup(candidate)}>
                      ✉️ Contact Information
                    </button>
                  </div>

                  {/* Match & Scores Section */}
                  <div className="candidate-match-info">
                    <div className="match-card">
                      <strong>Resume</strong> <br /> 
                      {candidate.Resume_Score} % Match
                      {penalty > 0 && (
                        <div className="score-breakdown">
                          <small>(Base: {baseScore}% - Penalty: {penalty}%)</small>
                        </div>
                      )}
                    </div>
                    <div className="match-card">
                      <strong>Screening Test</strong> <br />
                      {candidate.screening_overall_score
                        ? `${candidate.screening_overall_score} % Score`
                        : candidate.screening_scheduled_time
                          ? `Scheduled on  ${formatDate(candidate.screening_scheduled_time)}`
                          : "Not Scheduled"
                      }
                    </div>
                    <div className="match-card">
                      <strong>Personality Test</strong> <br />
                      {candidate.personality_overall_score
                        ? `${candidate.personality_overall_score} % Score`
                        : candidate.personality_scheduled_time
                          ? `Scheduled on ${formatDate(candidate.personality_scheduled_time)}`
                          : "Not Scheduled"
                      }
                    </div>
                    <div className="match-card">
                      <strong>Behavioral Test</strong> <br />
                      {candidate.behavioral_overall_score
                        ? `${candidate.behavioral_overall_score} % Score`
                        : candidate.behavioral_scheduled_time
                          ? `Scheduled on ${formatDate(candidate.behavioral_scheduled_time)}`
                          : "Not Scheduled"
                      }
                    </div>
                    <div className="match-card">
                      <strong>Coding Test</strong> <br />
                      {candidate.coding_overall_score
                        ? `${candidate.coding_overall_score} % Score`
                        : candidate.coding_scheduled_time
                          ? `Scheduled on  ${formatDate(candidate.coding_scheduled_time)}`
                          : "Not Scheduled"
                      }
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>


      </div>

      <Footer />
      {contactPopup && (
        // <div className="modal-overlay">
        //   <div className="popup-content">
        //     <h2>✉️ Contact Information</h2>
        //     <div style={{ display: "flex", gap: "10px", width: "100%", padding: "10px", alignItems: "baseline" }}>
        //       <span><strong>Email:</strong></span><input className="search-bar-all" style={{ width: "100%" }} type="text" value={cemail} />
        //     </div>
        //     <div style={{ display: "flex", gap: "10px", width: "100%", padding: "10px", alignItems: "baseline" }}>
        //       <span><strong>Phone:</strong></span><input className="search-bar-all" style={{ width: "100%" }} type="text" value={cphone} />
        //     </div>
        //     {/* <p><strong>Email:</strong> {cemail || 'Not provided'}</p>
        //     <p><strong>Phone:</strong> {cphone || 'Not provided'}</p> */}
        //     <button className="btn" onClick={() => saveNewEmailPhone()}>Save</button>
        //     <button className="btn cancel-btn" onClick={() => setContactPopup(false)}>Close</button>
        //   </div>
        // </div>
        <div className="modal-overlay">
          <div className="popup-content">
            <h2>✉️ Contact Information</h2>

            <div style={{ display: "flex", gap: "10px", width: "100%", padding: "10px", alignItems: "baseline" }}>
              <span><strong>Name:</strong></span>
              <input
                className="search-bar-all"
                style={{ width: "100%" }}
                type="text"
                value={cphone}
                onChange={(e) => setcphone(e.target.value)}
              />
            </div>

            <div style={{ display: "flex", gap: "10px", width: "100%", padding: "10px", alignItems: "baseline" }}>
              <span><strong>Email:</strong></span>
              <input
                className="search-bar-all"
                style={{ width: "100%" }}
                type="text"
                value={cemail}
                onChange={(e) => setcemail(e.target.value)}
              />
            </div>

            <button className="btn" onClick={() => saveNewEmailPhone()}>Save</button>
            <button className="btn cancel-btn" onClick={() => setContactPopup(false)}>Close</button>
          </div>
        </div>

      )}

      {showInterviewModal && selectedCandidates && (
        <ScheduleInterviewModal
          len={selectedCandidates.length}
          candidates={selectedCandidates}
          onClose={handleCloseModal}
          onSelectTest={handleSelectTest}
        />
      )}

      {showScheduleTestPopup && (
        <ScheduleTestt
          candidates={selectedCandidates}
          jobDetails={jobDetails}
          onClose={handleCloseScheduleTestPopup}
          onSelectTestCard={handleSelectTestCard}
        />
      )}

      {showVideo && selectedCandidate && (
        <VideoPopup onClose={() => setShowVideo(false)} candidate={selectedCandidate} />
      )}

      {showAudio && selectedCandidate && (
        <AudioPopup onClose={() => setShowAudio(false)} candidate={selectedCandidate} />
      )}

      {insightsCandidate && (
        <MeetingInsightsModal
          candidate={insightsCandidate}
          jobId={jobId}
          jobTitle={jobDetails.job_title}
          onClose={() => setInsightsCandidate(null)}
        />
      )}

    </div>
  );
};

export default CandidateList;
